import React from 'react';
import { auth } from './auth';

export const withAuth = (WrappedPage) => {
  const render = ({ ...pageProps }) => {
    return <WrappedPage {...pageProps} />;
  };

  render.getInitialProps = async (ctx) => {
    const {
      store: { getState },
    } = ctx;
    const {
      settings: { locale },
    } = getState();
    const POP_SESSION = auth.getAuthData({ ctx });

    if (!POP_SESSION) {
      auth.logout({ locale });
    }

    const componentProps = WrappedPage.getInitialProps && (await WrappedPage.getInitialProps(ctx));

    return { ...componentProps };
  };

  return render;
};
